import React, { useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import { useState } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";
import Spinner from "../Spinner/Spinner";

export default function CoinRateUpdate() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [Coin, setCoin] = useState("");
  const [HighLow, setHighLow] = useState("");
  const [Time, setTime] = useState("");
  const [Rate, setRate] = useState("");
  const [BasePrice, setBasePrice] = useState("");

  const [CoinList, setCoinList] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const CoinList_API = async () => {
    try {
      let res = await API?.post(
        "CoinListAPI",
        {
          loginid: userId,
          type: "1",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("setCoinList", res);

      setCoinList(res.data.data[0]);
    } catch (error) {
      console.log("Country API ERROR", error);
    }
  };

  const checkCoin = (e) => {
    const selectedCoinId = Number(e.target.value);

    setCoin(selectedCoinId);
  };

  const checkHighLow = (e) => {
    const selectedCoinId = Number(e.target.value);

    setHighLow(selectedCoinId);
  };
  const [selectedDateTime, setSelectedDateTime] = useState("");

  const handleDateTimeChange = (e) => {
    setSelectedDateTime(e.target.value);
  };
  useEffect(() => {
    CoinList_API();
  }, []);

  const CoinRateUpdate_API = async () => {
    try {
      setisLoading(true);
      if (Coin == "") {
        toast.error("Select Coin!!!");
        setisLoading(false);
      }
      if (HighLow == "" || HighLow == "0") {
        toast.error("Select Rate Type!!!");
        setisLoading(false);
      }
      if (selectedDateTime == "") {
        toast.error("Enter Start Date with Time!!!");
        setisLoading(false);
      }
      if (Time == "" || Time == "0") {
        toast.error("Enter Up/Down Time!!!");
        setisLoading(false);
      }
      if (Rate == "" || Rate == "0") {
        toast.error("Enter Up/Down Rate (%)!!!");
        setisLoading(false);
      }
      if (BasePrice == "" || BasePrice == "0") {
        toast.error("Enter Coin Base Price!!!");
        setisLoading(false);
      }

      const StartDateTime = selectedDateTime.replace("T", " ") + ":00.000";

      let responceRight = await API?.post(
        "/InsertCoinChangeForm",
        {
          loginid: userId,
          coin_id: Number(Coin),
          Rate_type: HighLow,
          startdate: StartDateTime,
          totalchangetimemint: Number(Time),
          pricechangerate: Number(Rate),
          CurrentPrice: Number(BasePrice),
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      console.log("My_Team", responceRight);
      if (responceRight.data.data == "SUCCESSFUL") {
        toast.success(responceRight.data.data);
        setisLoading(false);
        setCoin("");
        setHighLow("");
        setSelectedDateTime("");
        setTime("");
        setRate("");
        setBasePrice("");
      } else {
        toast.error(responceRight.data.data);
        setisLoading(false);
      }

      setisLoading(false);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Coin Rate Update</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="d-flex justify-content-between">
                                  <h1>Update Coin Rate With Time</h1>
                                </div>
                                <div class="form-group">
                                  <label>Coin List</label>

                                  <select
                                    name="Amount"
                                    className="form-control"
                                    value={Coin}
                                    onChange={checkCoin}
                                  >
                                    <option value="" disabled>
                                      Select Coin
                                    </option>
                                    {CoinList.map((Coin) => (
                                      <option
                                        key={Coin.id}
                                        value={Coin.id.toString()}
                                      >
                                        {Coin.coin_symbol}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div class="form-group">
                                  <label>Rate Type</label>
                                  <select
                                    name="Amount"
                                    className="form-control"
                                    value={HighLow}
                                    onChange={(e) => {
                                      setHighLow(e.target.value);
                                    }}
                                  >
                                    <option value="">Select High / Low</option>
                                    <option value="HIGH">HIGH</option>
                                    <option value="LOW">LOW</option>
                                  </select>
                                </div>
                                <div class="form-group">
                                  <label>Start Date with Time</label>
                                  <input
                                    type="datetime-local"
                                    id="datetimePicker"
                                    className="form-control"
                                    value={selectedDateTime}
                                    onChange={handleDateTimeChange}
                                  />
                                </div>

                                <div class="form-group">
                                  <label>Up/Down Time</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Up/Down Time"
                                    value={Time}
                                    onChange={(e) => {
                                      setTime(e.target.value);
                                    }}
                                  />
                                </div>
                                <div class="form-group">
                                  <label>Up/Down Rate (%)</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Up/Down Rate (%)"
                                    value={Rate}
                                    onChange={(e) => {
                                      setRate(e.target.value);
                                    }}
                                  />
                                </div>
                                <div class="form-group">
                                  <label>Coin Base Price</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Coin Price"
                                    value={BasePrice}
                                    onChange={(e) => {
                                      setBasePrice(e.target.value);
                                    }}
                                  />
                                </div>
                                {isLoading ? (
                                  <Spinner />
                                ) : (
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactive"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                      }}
                                      onClick={() => CoinRateUpdate_API()}
                                    >
                                      Add Trade
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
